import decodeJwt from 'jwt-decode';

const authProvider = {
  login: ({ username, password }) => {
    const request = new Request('https://tagmaservice2.it/auth/admin', {
      method: 'POST',
      body: JSON.stringify({ email: username, password }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    });
    return fetch(request)
      .then(response => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(({ token }) => {
        const decodedToken = decodeJwt(token);
        localStorage.setItem('auth', JSON.stringify(token));
        localStorage.setItem('admin', JSON.stringify(decodedToken));
      })
      .catch(() => {
        throw new Error('Network error')
      });
  },
  checkError: (error) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem('auth');
      return Promise.reject({ message: false });
    }
    // other error code (404, 500, etc): no need to log out
    return Promise.resolve();
  },
  checkAuth: () => localStorage.getItem('auth') ? Promise.resolve() : Promise.reject({ message: 'login.required' }),
  logout: () => {
    localStorage.removeItem('auth');
    return Promise.resolve('/login');
  },
  getIdentity: () => {
    try {
      const { _id, full_name } = JSON.parse(localStorage.getItem('admin'));
      return Promise.resolve({ id: _id, fullName: full_name });
    } catch (error) {
      return Promise.reject(error);
    }
  },
  // authorization
  getPermissions: params => Promise.resolve(),
};

export default authProvider;
